import { roundNumber } from './math';

export const convertCredits = (amount: string | number): number => Math.round(+amount * 10);

export const convertCentsToCredit = (amount: string | number): number => {
  if (!amount) return 0;

  return Math.round(+amount / 10);
};

export const minorUnitsToMajor = (amount: string | number, minorUnits = 2): number => {
  if (!amount) return 0;

  return roundNumber(+amount / 10 ** minorUnits, -minorUnits);
};

export const dollarsToCredits = (amount: number): number => {
  if (!amount) return 0;

  return Math.round(amount * 10);
};

export const dollarsToCents = (amount: number): number => {
  if (!amount) return 0;

  return Math.round(amount * 100);
};
